export const environment = {
  production: false,
  SW: true,
  URL_FRONT: 'https://portal-asistencia-qa.0s.cl',
  API_DOMAINS: {
    URL_ASISTENCIA: 'https://api-portal-asistencia-qa.0s.cl',
  },
  sso: {
    url: 'https://sso-dev.0s.cl/auth',
    realm: 'PORTALASISTENCIA',
    clientId: 'frontportalasistencia',
    sslRequired: 'external',
    publicClient: true,
    confidentialPort: 0,
  },
};
